// extracted by mini-css-extract-plugin
export default {"wrapper":"HomePage_wrapper__KPqZB","projects":"HomePage_projects__tADsU","title":"HomePage_title__PqBN-","projectCards":"HomePage_projectCards__QjNNu"};